/**
 * Created by muratzengin on 27/03/16.
 */
import {Injectable} from '@angular/core';
import {Message} from '@slarys/ufe-models';
import { Subject, Observable } from 'rxjs';
import * as _ from 'lodash';
import {AppSettings} from '@slarys/ufe-config';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class MessageService {
    private _messages: Observable<Array<Message>>;
    private _message: Observable<Message>;
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    public expandedItemSubject$ = new Subject<any>();

    expandedItemSubject() {
        return this.expandedItemSubject$.asObservable();
    }

    get messages(): Observable<Array<Message>> {
        return this._messages;
    }

    set messages(value: Observable<Array<Message>>) {
        this._messages = value;
    }
    get message(): Observable<Message> {
        return this._message;
    }

    set message(value: Observable<Message>) {
        this._message = value;
    }

    constructor(private httpClient: HttpClient) {}

    public getMessagesByItem(id, page?): Observable<any> {
        const url = AppSettings.API_ENDPOINT + '/messages/message/' + id + '?page=' + page;
        return this.httpClient.get(url);
    }

    public getUnreadMessages(page): Observable<any> {
        const url = AppSettings.API_ENDPOINT + '/messages/unread?page=' + page;
        return this.httpClient.get(url);
    }

    public getMessages(page): Observable<any> {
        const url = AppSettings.API_ENDPOINT + '/messages/message?page=' + page;
        return this.httpClient.get(url);
    }

    public getDeletedMessages(page): Observable<any> {
        const url = AppSettings.API_ENDPOINT + '/messages/deleted?page=' + page;
        return this.httpClient.get(url);
    }

    public getSentMessages(page): Observable<any> {
        const url = AppSettings.API_ENDPOINT + '/messages/sent?page=' + page;
        return this.httpClient.get(url);
    }

    public getMessage (id: string) {
        return this.httpClient.get(AppSettings.API_ENDPOINT + '/messages/message/' + id);
    }

    public sendMessage(message: Message) {
        return this.httpClient
            .post<Message>(
                AppSettings.API_ENDPOINT + '/messages/message',
                message,
                this.httpOptions
            )
            .pipe
            // catchError
            ();
    }

    public deleteMessage(message) {
        return this.httpClient
            .post<any>(
                AppSettings.API_ENDPOINT + '/messages/delete',
                message,
                this.httpOptions
            )
            .pipe();
    }

    public updateMessageStatus(message) {
        return this.httpClient
            .post<any>(
                AppSettings.API_ENDPOINT + '/messages/updatemessagestatus',
                message,
                this.httpOptions
            )
            .pipe();
    }

    public undeleteMessageStatus(message) {
        return this.httpClient
            .post<any>(
                AppSettings.API_ENDPOINT + '/messages/undeletemessagestatus',
                message,
                this.httpOptions
            )
            .pipe();
    }
}
